import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { createElement } from 'react';

import { InvoicePage } from '~/modules/invoice';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import {
  defaultInvoiceListSearch,
  validateInvoiceListSearch,
} from '../-invoiceListSearchParams';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.incoming, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/incoming/')({
  beforeLoad: createProtectedRoute({
    routePath: '/invoices/incoming/',
    ...routeParams,
  }),
  component: () => createElement(InvoicePage, { direction: 'incoming' }),
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(defaultInvoiceListSearch)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: validateInvoiceListSearch,
});

export const INCOMING_INVOICES = buildRouteExport({
  Route,
  ...routeParams,
});
